import React, { useState, forwardRef,  useEffect } from 'react';
import { NavLink, useParams} from 'react-router-dom';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuCaracterizacion from '../Caracterizacion/Componentes/MenuCaracterizacion';

export default function SeguridadAlimentaria(){
    const { token, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [swalProps, setSwalProps] = useState({});
    const [tiposEspacio, setTiposEspacio] = useState([]);
    
    const { control, handleSubmit, register, setValue, watch, getValues, reset, formState: { errors }} = useForm();
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    useEffect(() => {
        let now = new Date();
        const fetchData = async () => {
            let url = '/retorno/seguridadalimentaria/crearformseguridadalimentaria';
            let obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        fetchData();
    }, []);
    const onSubmit = async (data) => {
        const values = getValues();
        setCargando(true);
        let url;
        url = '/retorno/registrarseguridadalimentaria';
        try {
            const response = await apiService.post(url, values, token);
            if(response.status === 200){
                Mensaje('Registrar atencion', JSON.stringify(response.data));
                reset({
                    atencionesfields: []
                  });
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
    };
    
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Seguridad alimentaria</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Seguridad alimentaria</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia}></MenuCaracterizacion>
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-info">
                        <div className="card-header">
                            <h3 className="card-title">Seguridad alimentaria</h3>
                        </div>
                        {/* /.card-header */}
                        {/* form start */}
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                                <DatosCabezaFamilia datos={CabezaFamiliaDatos}></DatosCabezaFamilia>
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Estado del Lote</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Tipo de espacio con que cuenta la familia para el proyecto.  </label>
                                            <select {...register('tipoEspacio', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposEspacio.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tipTipoespacio}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tipoEspacio && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                        <label>	&aacute;rea del espacio con que cuenta la familia para el proyecto en metros cuadrados:</label>
                                            <input {...register('areaEspacio')}  className="form-control" placeholder="0"/>
                                            {errors.areaEspacio && <p style={{color: 'red'}}>Digite area</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Hay presencia de escombros en el espacio para el proyecto?</label>
                                            <select {...register('escombros', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.escombros && <p style={{color: 'red'}}>Seleccione opcion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Hay plantas o cultivos ya establecidos en el espacio disponible para la implementaci&oacute;n del proyecto?</label>
                                            <select {...register('plantasCultivos', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.plantasCultivos && <p style={{color: 'red'}}>Seleccione opcion</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Posibles observaciones encontradas con respecto del estado del lote</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observaciones', { required: true })}
                                                placeholder="Observaciones"
                                            />
                                            {errors.observaciones && <p style={{color: 'red'}}>Favor digite observaciones</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Estado de lo Recursos Naturales</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Hay presencia de materia org&aacute;nica en el espacio para el proyecto?</label>
                                            <select {...register('materiaOrganica', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.materiaOrganica && <p style={{color: 'red'}}>Seleccione opcion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Hay disponibilidad de agua en el espacio para el proyecto?</label>
                                            <select {...register('disponibilidadAgua', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.disponibilidadAgua && <p style={{color: 'red'}}>Seleccione opcion</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Hay evidencia de pr&aacute;cticas de conservaci&oacute;n de los recursos naturales?</label>
                                            <select {...register('practicasConservacion', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.practicasConservacion && <p style={{color: 'red'}}>Seleccione opcion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>	Nombre del tipo de pr&aacute;ctica de conservaci&oacute;n que se utiliza.:</label>
                                            <input {...register('nombrePractica')}  className="form-control" placeholder=""/>
                                            {errors.nombrePractica && <p style={{color: 'red'}}>Digite area</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observacionesEstaRecursos">Posibles observaciones encontradas con respecto del estado de los recursos naturales.</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observacionesEstaRecursos', { required: true })}
                                                placeholder="Observaciones"
                                            />
                                            {errors.observacionesEstaRecursos && <p style={{color: 'red'}}>Favor digite observaciones</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Experiencian En Sistemas Agroecol&oacute;gicos</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>El grupo familiar tiene experiencia en la implementaci&oacute;n o en el trabajo con sistemas agroecol&oacute;gicos?</label>
                                            <select {...register('tieneExperiencia', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.tieneExperiencia && <p style={{color: 'red'}}>Seleccione opcion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Tiempo que tiene de experiencia en la implementaci&oacute;n o el trabajo con sistemas agroecol&oacute;gicos en meses.</label>
                                            <input {...register('tiempoExperiencia')}  className="form-control" placeholder="0"/>
                                            {errors.tiempoExperiencia && <p style={{color: 'red'}}>Digite area</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observacionesAgroecologicos">Posibles observaciones encontradas con respecto de la experiencia del grupo familiar en sistemas agroecol&oacute;gicos.</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observacionesAgroecologicos', { required: true })}
                                                placeholder="Observaciones"
                                            />
                                            {errors.observacionesAgroecologicos && <p style={{color: 'red'}}>Favor digite observaciones</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                {/* /.card-body */}
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-info">Guardar</button>
                                
                            </div>
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}